import { useEffect, useState } from "react";
import { Socket } from "socket.io-client";
import { Skeleton } from "@mui/material";
import { IImages } from "src/app/interfaces/chat-image";
import { toImageSrc } from "app/store/imageSrc";
import { ChatImageModel } from "src/app/models/chat-image";

interface ChatSuspenseProps {
    messageId: string;
    source: string;
    idx: number | string;
    messageSocket: Socket;
    initialSend: boolean;
    initialImage?: Partial<IImages>[];
    // fetchImages(messageId: string): Promise<IImages[]>
}

export default function ChatImageSuspense({
    idx,
    messageId,
    messageSocket,
    initialSend,
    initialImage,
}: ChatSuspenseProps) {
    const [imageString, setImageString] = useState<Partial<any>[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const eventName = `message-image::found-${messageId}`;

    const fetchImageSk = async () => {
        setIsLoading(true);
        const _image = new ChatImageModel([{ message: messageId }]);
        _image.fetchImages(messageId);
    };

    useEffect(() => {
        if (initialSend && initialImage) setImageString(initialImage);
        else {
            fetchImageSk();
            messageSocket.on(eventName, (image) => {
                setImageString(Array.isArray(image) ? image : []);
                messageSocket.off(eventName);
                setIsLoading(false);
            });
        }
    }, [messageSocket, messageId, initialSend, initialImage]);

    return (
        <>
            {isLoading && (
                <Skeleton
                    sx={{ bgcolor: "grey.500", borderRadius: "12px" }}
                    variant="rounded"
                    animation="pulse"
                    width={300}
                    height={200}
                    key={idx}
                />
            )}
            {imageString?.map((doc, index) => (
                // base64 today; an https blob URL once the backend's
                // RC_MEDIA_URL_FIELDS is on. Prefixing a URL as base64 broke it.
                <img
                    key={`${idx}-${index}`}
                    src={toImageSrc(doc.image)}
                    alt={`chat_image_${index}`}
                    onLoad={() => setIsLoading(false)}
                    onError={() => setIsLoading(false)}
                    style={{
                        maxWidth: "100%",
                        height: "auto",
                        maxHeight: "300px",
                        display: "block",
                        margin: "10px 0",
                        borderRadius: "12px",
                    }}
                />
            ))}
            {/* {(Array.isArray(imageString) && imageString.length > 0) && (
                imageString.map((string, index) => (
                    <img
                        key={index}
                        src={toImageSrc(string.image)}
                        alt="chat_image"
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            maxHeight: '300px',
                            display: 'block',
                            margin: '10px 0',
                            borderRadius: '12px',
                        }}
                    />
                ))
            )} */}
            {/* {Array.isArray(imageString) && imageString.length > 0 ? (
                imageString.map((string, index) => (
                    <img
                        key={index}
                        src={toImageSrc(string.image)}
                        alt="chat_image"
                        style={{
                            maxWidth: '100%',
                            height: 'auto',
                            maxHeight: '300px',
                            display: 'block',
                            margin: '10px 0',
                            borderRadius: '12px',
                        }}
                    />
                ))
            ) : (
                !isLoading && <></>
            )} */}
        </>
    );
}
